// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Err from "../bindings/Err.js";
import * as Sea from "../bindings/Sea.js";
import * as Preact from "../bindings/Preact.js";
import * as Storage from "./Storage.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

async function getDeviceIdInternal(keypair) {
  return await window.SEA.work(keypair.pub, null, null, {
    name: "SHA-256"
  });
}

async function generateKeyPair() {
  if (!Sea.isSeaAvailable()) {
    Err.$$throw("GunDB SEA is not loaded");
  }
  let existing = Storage.getKeypair();
  if (existing !== undefined && existing.pub !== "" && existing.priv !== "") {
    return existing;
  }
  let keypair = await window.SEA.pair();
  Storage.storeKeypair(keypair);
  let deviceId = await getDeviceIdInternal(keypair);
  Storage.storeDeviceId(deviceId);
  return keypair;
}

async function getDeviceId(keypair) {
  if (!Sea.isSeaAvailable()) {
    Err.$$throw("GunDB SEA is not loaded");
  }
  let stored = Storage.getDeviceId();
  if (stored !== undefined) {
    return stored;
  }
  let pair;
  if (keypair !== undefined) {
    pair = keypair;
  } else {
    let kp = Storage.getKeypair();
    pair = kp !== undefined ? kp : await generateKeyPair();
  }
  return await window.SEA.work(pair.pub, null, null, {
    name: "SHA-256"
  });
}

async function doProofOfWork(data, keypair) {
  if (!Sea.isSeaAvailable()) {
    Err.$$throw("GunDB SEA is not loaded");
  }
  let pair;
  if (keypair !== undefined) {
    pair = keypair;
  } else {
    let kp = Storage.getKeypair();
    pair = kp !== undefined ? kp : await generateKeyPair();
  }
  return await window.SEA.work(data, pair);
}

async function verifyWork(data, proof, keypair) {
  if (!Sea.isSeaAvailable()) {
    Err.$$throw("GunDB SEA is not loaded");
  }
  let expectedWork = await window.SEA.work(data, keypair);
  return proof === expectedWork;
}

async function signData(data, keypair) {
  if (!Sea.isSeaAvailable()) {
    Err.$$throw("GunDB SEA is not loaded");
  }
  let pair;
  if (keypair !== undefined) {
    pair = keypair;
  } else {
    let kp = Storage.getKeypair();
    pair = kp !== undefined ? kp : Err.$$throw("No keypair available for signing");
  }
  return await window.SEA.sign(data, pair);
}

async function verifySignature(signedData, publicKey) {
  if (!Sea.isSeaAvailable()) {
    Err.$$throw("GunDB SEA is not loaded");
  }
  return Primitive_option.fromNullable(await window.SEA.verify(signedData, publicKey));
}

function expose() {
  Preact.setWindowProperty("PoW", {
    generateKeyPair: generateKeyPair,
    getDeviceId: getDeviceId,
    doProofOfWork: doProofOfWork,
    verifyWork: verifyWork,
    signData: signData,
    verifySignature: verifySignature,
    hasKeypair: Storage.hasKeypair,
    getStoredKeypair: Storage.getKeypair
  });
}

let hasKeypair = Storage.hasKeypair;

let getStoredKeypair = Storage.getKeypair;

export {
  getDeviceIdInternal,
  generateKeyPair,
  getDeviceId,
  doProofOfWork,
  verifyWork,
  signData,
  verifySignature,
  hasKeypair,
  getStoredKeypair,
  expose,
}
/* No side effect */
